import { Component, OnInit, AfterViewInit, Input, DestroyRef } from '@angular/core';
import { tileLayer, latLng, FeatureGroup, featureGroup, marker, DrawEvents, Layer } from 'leaflet';
import * as L from 'leaflet';
import { FormGroup } from '@angular/forms';
import { distinctUntilChanged, debounceTime, map } from 'rxjs/operators';
import { MapService } from '@app/shared/services/map.service';
import { DistrictsService } from '@app/districts/districts.service';
import { SHARED_IMPORTS } from '@app/shared/shared.imports';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { LeafletDrawModule } from '@bluehalo/ngx-leaflet-draw';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-draw-map',
  templateUrl: './draw-map.component.html',
  styleUrls: ['./draw-map.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS, LeafletModule, LeafletDrawModule]
})
export class DrawMapComponent implements OnInit, AfterViewInit {
  layerType: string;
  drawnItems: FeatureGroup = featureGroup();
  layers: Layer[] = [];
  show: boolean;
  addMode: boolean = true;
  @Input() form: FormGroup; //map: any;
  @Input() controlName: string;
  @Input() field: any;
  map: L.Map;
  options = {};

  drawOptions = {};

  drawLocal = {};

  editRowMode: boolean;
  defaultParentName: string = 'points';
  shapeType: string;
  currentZoom: number;
  points: any[];
  names: any[];
  pointsLoaded: boolean;

  constructor(
    private mapService: MapService,
    private districtsService: DistrictsService,
    private destroyRef: DestroyRef
  ) {}

  onDrawStart(e: any) {
    let childMap = this.field.form.map && this.field.form.map.childMap;
    if (!childMap) {
      // add mode in parent map
      if (this.addMode) {
        console.log('parent add mode ');
        if (this.layers.length > this.points.length) {
          this.layers.pop();
          this.drawnItems.clearLayers();
          this.editRowMode = false;
        }
      }
      //update mode in parent map
      else {
        console.log('parent edit mode ');

        let removedLayer = this.layers.find(
          layer =>
            (layer as any)['_latlng']['lat'] === this.mapService.editedLayerParent['lat'] &&
            (layer as any)['_latlng']['lng'] === this.mapService.editedLayerParent['lng']
        );
        this.layers = this.layers.filter(
          layer =>
            (layer as any)['_latlng']['lat'] !== this.mapService.editedLayerParent['lat'] &&
            (layer as any)['_latlng']['lng'] !== this.mapService.editedLayerParent['lng']
        );
        this.drawnItems.removeLayer(removedLayer);
      }
    } else {
      if (this.mapService.removeLayer && !this.editRowMode) {
        console.log('case 1');

        let lastLayer = this.layers[this.layers.length - 1];
        this.layers.pop();
        this.drawnItems.removeLayer(lastLayer);
        this.editRowMode = false;
      }
      if (this.editRowMode) {
        let removedLayer = this.layers.find(
          layer =>
            (layer as any)['_latlng']['lat'] === this.mapService.selectedLayer['lat'] &&
            (layer as any)['_latlng']['lng'] === this.mapService.selectedLayer['lng']
        );
        this.layers = this.layers.filter(
          layer =>
            (layer as any)['_latlng']['lat'] !== this.mapService.selectedLayer['lat'] &&
            (layer as any)['_latlng']['lng'] !== this.mapService.selectedLayer['lng']
        );
        this.drawnItems.removeLayer(removedLayer);
      }
    }
  }

  setOptions() {
    console.log('SEToPtions works');

    let childMap = this.field.form.map && this.field.form.map.childMap;
    let check = childMap && this.mapService.currentZoom && this.mapService.defaultPoints;
    this.options = {
      layers: [
        tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: 'Open Street Map' })
      ],
      zoom: check ? this.mapService.currentZoom : 12,
      center: check
        ? latLng({ lat: this.mapService.defaultPoints['lat'], lng: this.mapService.defaultPoints['lng'] })
        : latLng({ lat: 21.42251, lng: 39.826168 })
    };

    this.drawOptions = {
      position: 'bottomright',
      draw: {
        marker: this.setDrawShapes(this.field.form.map.marker, 'marker'),
        polyline: this.setDrawShapes(this.field.form.map.polyline, 'polyline'),
        circlemarker: this.setDrawShapes(this.field.form.map.circlemarker, 'circlemarker'),
        circle: this.setDrawShapes(this.field.form.map.circle, 'circle'),
        rectangle: this.setDrawShapes(this.field.form.map.rectangle, 'rectangle'),
        polygon: this.setDrawShapes(this.field.form.map.polygon, 'polygon')
      },
      edit: {
        featureGroup: this.drawnItems,
        remove: true
      }
    };

    this.drawLocal = {
      draw: {
        toolbar: {
          buttons: {
            polygon: 'Draw a polygon!',
            rectangle: 'Draw a rectangle!',
            circle: 'Draw a circle!'
          }
        }
      }
    };
  }
  setDrawShapes(showShape: boolean, type: string) {
    var customMarker = L.Icon.extend({
      options: {
        shadowUrl: null,
        iconAnchor: new L.Point(12, 12),
        iconSize: new L.Point(25, 41),
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
        className: 'marker-margin'
      }
    });
    if (showShape && type === 'circle') {
      let circleOptions = { shapeOptions: { color: 'red' } };
      return circleOptions;
    }
    if (showShape && type === 'marker') {
      let markerOptions = { shapeOptions: { color: this.field.form.map.color }, icon: new customMarker() };
      this.shapeType = type;
      return markerOptions;
    }
    return showShape;
  }

  onDrawCreated(e: any) {
    console.log('e in created', e);
    const layer = (e as DrawEvents.Created).layer;
    let points: any;
    this.shapeType = e.layerType;
    let childMap = this.field.form.map && this.field.form.map.childMap;
    let iconColor = childMap ? (this.editRowMode ? 'black' : 'green') : 'red';
    if (this.shapeType === 'marker') {
      points = e.layer._latlng;
      if (this.editRowMode) this.mapService.selectedLayer = points;
      let icon = this.mapService.setIcon(iconColor);
      let layer = marker(points, { icon: icon });
      this.layers.push(layer);
      this.drawnItems.addLayer(layer);
      console.log('this.layers in add', this.layers);
      this.form.get(this.controlName).setValue(points);
      if (!childMap) {
        this.mapService.editedLayerParent = points;
        this.mapService.selectedLayer = points;
        this.form.markAsDirty();
      } else {
        if (!this.editRowMode) this.mapService.removeLayer = true;
      }
    }
  }

  onEditStop(e: any) {
    console.log('e on edit stop');
    this.getPointsOnEdit();
    this.mapService.disableStep$.next(false);
  }

  getPointsOnEdit() {
    if (this.shapeType === 'marker') {
      let dynamicKey = Object.keys((this.drawnItems as any)['_layers'])[0];
      let points = (this.drawnItems as any)['_layers'][dynamicKey]['_latlng'];
      this.form.get(this.controlName).setValue(points);
      console.log('form value in edit', this.form.value);
      this.mapService.selectedLayer = points;
      let childMap = this.field.form.map && this.field.form.map.childMap;
      if (!childMap) {
        if (!this.addMode) this.mapService.editedLayerParent = points;
        this.form.markAsDirty();
      }
    }
  }

  // this.form.markAsDirty();
  //}
  setDrawnPoints() {
    let childMap = this.field.form.map && this.field.form.map.childMap;
    if (!childMap) {
      this.mapService
        .getCurrentPoints()
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          map((data: any) => {
            data.data.forEach((d: any, index: number) => {
              const points = d['points'];
              if (points) {
                const { zoom, ...rest } = points;
                d['points'] = rest;
              }
            });
            return data.data;
          })
        )
        .subscribe((data: any) => {
          this.pointsLoaded = true;
          if (!childMap) {
            const entries = data
              .map((d: any) => ({
                point: d?.[this.field.name],
                name: d?.name,
                id: d?.['id']
              }))
              .filter((e: any) => e.point && e.point.lat != null && e.point.lng != null);

            this.points = entries.map((e: any) => e.point);
            this.names = entries.map((e: any) => e.name);
            this.mapService.ids = entries.map((e: any) => e.id);
            this.points.forEach((element: any, index: number) => {
              let icon = this.mapService.setIcon('gold');
              if (this.names.length) {
                let layer = marker([element.lat, element.lng], { icon: icon }).bindTooltip(this.names[index]);
                this.layers.push(layer);
              }
            });
          }
        });
    } else {
      if (this.mapService.layers && this.mapService.layers.length) {
        let layers = [...this.mapService.layers];
        this.layers = [];
        layers.forEach(layer => {
          let options = layer['options'];
          let l = marker([layer['_latlng'].lat, layer['_latlng'].lng], options);
          this.layers.push(l);
        });
      }
    }
  }

  highlightEditedPoint(latLng: any, index: number, name: string) {
    const hasValidIndex = typeof index === 'number' && index >= 0;
    if (this.points && hasValidIndex && index < this.points.length) {
      this.points.splice(index, 1);
    }
    if (this.names && hasValidIndex && index < this.names.length) {
      this.names.splice(index, 1);
    }
    if (this.points && this.names) {
      this.initLayers(this.points, 'gold', this.names);
    }
    this.highlightLayer(latLng, 'red', name);
    this.form.get(this.controlName).setValue(latLng);
    this.setMapView(latLng, this.mapService.currentZoom);
  }

  ngOnInit() {
    setTimeout(() => {
      this.show = true;
    }, 10);

    this.setOptions();
    this.setDrawnPoints();

    //show point on map on edit
    if (this.mapService.editDrawMap$) {
      // this.show = false;
      this.mapService.editDrawMap$
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          distinctUntilChanged(),
          debounceTime(50),
          map((item: any) => {
            return item;
          })
        )
        .subscribe((item: any) => {
          let childMap = this.field.form.map && this.field.form.map.childMap;
          if (!childMap && item) {
            const ids = this.mapService.ids || [];
            const index = ids.indexOf(item['id']);
            const points = item?.[this.controlName];
            if (!points) {
              return;
            }
            const { zoom, ...rest } = points;
            this.mapService.editedLayerParent = null;
            this.mapService.editedLayerParent = rest;
            this.mapService.currentZoom = zoom;
            if (!this.points) {
              setTimeout(() => {
                // console.log("this.points", this.points);
                this.highlightEditedPoint(rest, index, item.name);
              }, 700);
            } else {
              this.highlightEditedPoint(rest, index, item.name);
            }
          }
        });
    }

    //go to second tab
    this.mapService.navNext$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      console.log('nav next data', data);
      this.addMode = data['addMode'];
      let icon = this.mapService.setIcon('red');
      let layer = marker(data['points'], { icon: icon }).bindTooltip(data['name']);
      let childMap = this.field.form.map && this.field.form.map.childMap;
      this.mapService.defaultPoints = null;
      this.mapService.defaultPoints = data['points'];
      if (childMap && data['points']) {
        this.layers = !this.layers.length ? [] : this.layers.splice(0, 1);
        this.layers.unshift(layer);
        // console.log('this.layers', this.layers);
      }

      if (childMap && data['rows'] && data['rows'].length) {
        let rows = data['rows'].map((d: any) => d[this.controlName]).filter((f: any) => f);
        let names = data['rows'].map((d: any) => d.name).filter((n: string) => n);
        this.initLayers(rows, 'green', names);
        // this.setMapView(this.mapService.defaultPoints, this.mapService.currentZoom);
      }
      // this.refreshMap();
      if (!data['addMode']) {
        // console.log("edit mode");
        this.setMapView(data['points'], this.mapService.currentZoom, 50);
      } else this.setMapView(data['points'], this.mapService.currentZoom);

      // console.log(data['points'], this.mapService.currentZoom);
    });

    //show points in child map if user edit row in table
    this.mapService.editRowMap$
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        // console.log("data in edit row", data);
        this.editRowMode = true;
        let childMap = this.field.form.map && this.field.form.map.childMap;
        if (childMap) {
          // console.log("ctr name", this.controlName);
          let rows = [];
          let names = [];
          rows = data['rows'].map((d: any) => d[this.controlName]).filter((f: any) => f);
          // console.log("rows", rows);
          names = data['rows'].map((d: any) => d.name).filter((f: any) => f);
          this.mapService.previousLayers = { layers: [...rows], names: [...names] };
          this.mapService.selectedLayer = data['points'];
          // console.log('this.mapService.selectedLayer', this.mapService.selectedLayer);
          let copyRows = [...rows];
          copyRows.splice(data.index, 1);
          names.splice(data.index, 1);
          this.initLayers(copyRows, 'green', names);
          this.highlightLayer(this.mapService.selectedLayer, 'black');
          this.setMapView(this.mapService.selectedLayer, this.mapService.currentZoom);
          this.refreshMap();
          // this.form.get(this.controlName).setValue(this.mapService.selectedLayer)
        }
      });

    // set markers when user add or cancel when user edit row
    this.mapService.removeChildLayer$
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        let childMap = this.field.form.map && this.field.form.map.childMap;

        if (data['action'] && data['action'] === 'cancel') {
          if (childMap) {
            this.initLayers(this.mapService.previousLayers.layers, 'green', this.mapService.previousLayers.names);
            this.setMapView(this.mapService.defaultPoints, this.mapService.currentZoom);
            this.refreshMap();
          }
        }
        if (data['action'] && data['action'] === 'add') {
          console.log('add work');
          if (childMap) {
            if (this.editRowMode) {
              let rows = data['rows'].map((d: any) => d[this.controlName]).filter((f: any) => f);
              let names = data['rows'].map((d: any) => d.name).filter((f: any) => f);
              // console.log('rows', rows);
              // console.log('names', names);
              this.initLayers(rows, 'green', names);
              this.setMapView(this.mapService.defaultPoints, this.mapService.currentZoom);
              this.refreshMap();
              this.form.markAsDirty();
            }
          }
          this.mapService.layers = [...this.layers];
          this.editRowMode = false;
        }
      });

    //hide map when add and update map
    this.mapService.showHideMap$
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe((hide: boolean) => {
        this.addMode = false;
        this.show = hide;
      });
  }
  highlightLayer(latLng: any, color: string, name: string = null, delay = 0) {
    if (latLng) {
      let icon = this.mapService.setIcon(color);
      let layer = name ? marker(latLng, { icon: icon }).bindTooltip(name) : marker(latLng, { icon: icon });
      this.drawnItems.addLayer(layer);
      this.layers.push(layer);
    }
  }

  initLayers(latLngs: any[], color: string, names: any[] = null) {
    // console.log('latLngs', latLngs);
    // console.log('names', names);
    this.drawnItems.clearLayers();
    let childMap = this.field.form.map && this.field.form.map.childMap;
    // console.log('layers', this.layers);
    if (childMap) this.layers = [this.layers[0]];
    else this.layers = [];
    latLngs.forEach((latlng: any, index: number) => {
      let icon = this.mapService.setIcon(color);
      let layer = marker(latlng, { icon: icon }).bindTooltip(names[index]);
      // this.drawnItems.addLayer(layer);
      this.layers.push(layer);
    });
  }
  refreshMap(delay = 1) {
    console.log('delay', delay);

    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, delay);
  }

  setMapView(latlng: any, zoom: number, delay = 1) {
    // console.log("add mode", this.addMode);
    let childMap = this.field.form.map && this.field.form.map.childMap;
    if (!this.addMode && childMap && latlng) {
      this.refreshMap();
      console.log('zoom', zoom);
      setTimeout(() => {
        this.map.setView([latlng['lat'], latlng['lng']], zoom);
      }, delay);
    } else if (latlng) this.map.setView([latlng['lat'], latlng['lng']], zoom);
  }

  // get the reference to the map
  onMapReady(map: L.Map) {
    this.map = map;
  }

  onLeafletMapZoomEnd(map: any) {
    let childMap = this.field.form.map && this.field.form.map.childMap;
    if (!childMap) this.mapService.currentZoom = map.target.getZoom();
  }

  onDrawStop(e: any) {
    // console.log('draw stop work', e);
  }

  onEditVertex() {
    this.getPointsOnEdit();
  }

  onDrawEditStart(e: any) {
    console.log('edit start', e);
    this.mapService.disableStep$.next(true);
  }

  onDeleteStop() {
    console.log('on delete work');

    this.form.get(this.field.name).setValue(null);
  }

  ngAfterViewInit() {}
}
